import { cn } from '@/shared/lib/utils'

/**
 * GTM loading indicator: a tiny share-price chart that keeps drawing itself
 * upward — the same motif as the halftone background. Sized like a lucide
 * icon (`size-4` by default) and coloured by `currentColor`; the motion lives
 * in styles.css (`.gtm-ticker-spinner`) and stops under reduced motion.
 */
export function GtmSpinner({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={cn('gtm-ticker-spinner size-4 shrink-0', className)}
    >
      <path d="M3 4v16h18" opacity={0.3} />
      <path
        d="M6 16l4-4 3 2.5 6-7.5"
        pathLength={1}
        className="gtm-ticker-spinner__line"
      />
      <circle
        cx="19"
        cy="7"
        r="1.8"
        fill="currentColor"
        stroke="none"
        className="gtm-ticker-spinner__head"
      />
    </svg>
  )
}
